import React from 'react';
import {FaHome} from 'react-icons/fa';
import {IoIosArrowForward} from 'react-icons/io';
import { NavLink } from 'react-router-dom';


import './SocialAdmin.css';


function SocialLinks(props) {
    return (
        <div >
             <div className={props.isOpen?'view2':'view1'}>
             
                <div className='DashboardHeader'>
                    <div className='pull-left'>
                        <div className='page-title'>Social Links</div>
                    </div>
                    
                    <ol className='pull-right'>
                        <li style={{display:'inline-block'}}>
                            <FaHome style={{verticalAlign:'text-top'}} />
                            <NavLink className='dashLink' to='/admin/dashboard' style={{verticalAlign:'center'}}> Home</NavLink>
                            <IoIosArrowForward style={{verticalAlign:'text-bottom'}} />
                        </li>
                        <li active >Social Links</li>
                        
                    </ol>
                </div>
                <div className='contenu'>
                <p>Contrary to popular belief, Lorem Ipsum is not simply random text.
                It has roots in a piece of classical Latin literature from 45 BC, making
                it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney
                College in Virginia, looked up one of the more obscure Latin words, consectetur,
                from a Lorem Ipsum passage, and going through the cites of the word in classical
                literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32
                and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero,
                written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
                Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line
                in section 1.10.32.The standard chunk of Lorem Ipsum used since the 1500s is reproduced below
                for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero
                are also reproduced in their exact original form, accompanied by English versions from the 1914 translation
                by H. Rackham.Where can I get some?There are many variations of passages of Lorem Ipsum available,
                but the majority have suffered alteration in some form, by injected humour, or randomised words which
                don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be 
                sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on
                the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the
                Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures,
                to generate Lorem Ipsum which looks reasonable. The generated Lo</p>
                </div>
                
            </div>
            
        </div>
    )
}

export default SocialLinks
